import React, { useEffect } from 'react'
import AppRoutes from './routes'
import { ToastContainer, toast, Slide } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function App() {
  useEffect(() => {
    const forbiddenHandler = () => {
      toast.error('Non hai i permessi necessari per questa risorsa.', {
        theme     : 'dark',
        position  : 'top-center',
        autoClose : 3500,
        transition: Slide,
      })
    }

    const errorHandler = (e) => {
      const { message } = e.detail || {}
      toast.error(message || 'Si è verificato un errore. Riprova.', {
        theme     : 'dark',
        position  : 'top-center',
        autoClose : 4000,
        transition: Slide,
      })
    }

    window.addEventListener('api:forbidden', forbiddenHandler)
    window.addEventListener('api:error', errorHandler)
    return () => {
      window.removeEventListener('api:forbidden', forbiddenHandler)
      window.removeEventListener('api:error', errorHandler)
    }
  }, [])

  return (
    <>
      <AppRoutes />
      <ToastContainer newestOnTop />
    </>
  )
}

export default App
